import {
  Button,
  Checkbox,
  Form,
  Input,
  Card,
  Row,
  notification,
  Typography,
  Space
} from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from 'src/store/auth'

import './LoginForm.css'

const { Text } = Typography

const LoginForm = () => {
  const [form] = Form.useForm()
  const emailValue = Form.useWatch('email', form)
  const passwordValue = Form.useWatch('password', form)

  const [api, contextHolder] = notification.useNotification()
  const [error, setError] = useState(null)

  const { loginUser, refreshUser } = useAuthStore((store) => store)

  const onFinish = async (values) => {
    const res = await loginUser(values)
    if (!res?.success) {
      api.error({
        message: `Sign In Error`,
        description: res?.error || 'Error',
        placement: 'topRight'
      })

      setError(res)
    } else {
      refreshUser()
    }
  }

  const onFinishFailed = (errorInfo) => {}

  useEffect(() => {
    setError(null)
  }, [emailValue, passwordValue])

  return (
    <Card
      title='Sign In'
      style={{
        maxWidth: 400,
        width: '100%'
      }}
      headStyle={{
        textAlign: 'center',
        fontSize: '30px',
        padding: '20px'
      }}
    >
      {contextHolder}
      <Form
        form={form}
        className='clear-form'
        layout='vertical'
        name='basic'
        style={{
          maxWidth: 400,
          width: '100%'
        }}
        initialValues={{
          remember: true
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        {error && (
          <Space style={{ marginBottom: 15 }}>
            <Text type='danger'>{error?.error}</Text>
          </Space>
        )}
        <Form.Item
          name='email'
          label='Email'
          rules={[{ required: true, message: 'Please input your email!' }]}
        >
          <Input
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder='Email'
          />
        </Form.Item>
        <Form.Item
          label='Password'
          name='password'
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password
            prefix={<LockOutlined className='site-form-item-icon' />}
            type='password'
            placeholder='Password'
          />
        </Form.Item>
        <Form.Item>
          <Row justify='space-between' align='center'>
            <Form.Item name='remember' valuePropName='checked' noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
          </Row>
        </Form.Item>

        <Form.Item>
          <Button
            type='primary'
            block
            htmlType='submit'
            className='login-form-button'
          >
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
export default LoginForm
